import { createFileRoute } from '@tanstack/react-router'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  return (
    <div className="mx-auto w-full max-w-3xl px-6 py-16">
      <Card className="text-center">
        <CardHeader>
          <CardTitle className="text-2xl">Order tracker</CardTitle>
          <CardDescription className="mt-2 text-base">
            Open the &ldquo;Track your order&rdquo; link in any email about your order.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-sm">
            Can&apos;t find it? Reply to any email about your order and we&apos;ll send it again.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
